import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 text-secondary-300">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">麻花影院</span>
            </div>
            <p className="text-sm text-secondary-400 leading-relaxed">
              麻花影院免费观看平台，为您提供海量高清电影、电视剧、综艺、动漫免费在线播放服务。更新快、不卡顿，让观影更轻松愉快。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-secondary-400 hover:text-primary-400 cursor-pointer transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-sm text-secondary-400 hover:text-primary-400 cursor-pointer transition-colors">电影</Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-sm text-secondary-400 hover:text-primary-400 cursor-pointer transition-colors">电视剧</Link>
              </li>
              <li>
                <Link to="/category/variety" className="text-sm text-secondary-400 hover:text-primary-400 cursor-pointer transition-colors">综艺</Link>
              </li>
              <li>
                <Link to="/category/anime" className="text-sm text-secondary-400 hover:text-primary-400 cursor-pointer transition-colors">动漫</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">热门推荐</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/detail/1" className="text-sm text-secondary-400 hover:text-primary-400 cursor-pointer transition-colors">流浪地球3</Link>
              </li>
              <li>
                <Link to="/detail/9" className="text-sm text-secondary-400 hover:text-primary-400 cursor-pointer transition-colors">庆余年第二季</Link>
              </li>
              <li>
                <Link to="/detail/15" className="text-sm text-secondary-400 hover:text-primary-400 cursor-pointer transition-colors">斗破苍穹</Link>
              </li>
              <li>
                <Link to="/detail/10" className="text-sm text-secondary-400 hover:text-primary-400 cursor-pointer transition-colors">狂飙</Link>
              </li>
              <li>
                <Link to="/detail/3" className="text-sm text-secondary-400 hover:text-primary-400 cursor-pointer transition-colors">封神第二部</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-secondary-400 hover:text-primary-400 cursor-pointer transition-colors">品牌介绍</Link>
              </li>
              <li>
                <span className="text-sm text-secondary-500">客服邮箱：kefu@mahua.tv</span>
              </li>
              <li>
                <span className="text-sm text-secondary-500">工作时间：周一至周日 9:00-22:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-800 mt-10 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between max-w-7xl mx-auto gap-4">
            <p className="text-sm text-secondary-500">
              &copy; {currentYear} 麻花影院 mahuayingyuan.com - 麻花影院免费观看 All Rights Reserved.
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-secondary-600">友情链接</span>
              <a href="#" rel="nofollow" className="text-xs text-secondary-500 hover:text-primary-400 cursor-pointer transition-colors">影视推荐</a>
              <a href="#" rel="nofollow" className="text-xs text-secondary-500 hover:text-primary-400 cursor-pointer transition-colors">在线影院</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}